import { CustomerInvitingTable } from './CustomerInvitingTable';
export default CustomerInvitingTable;
